var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInventory = function SvgInventory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 63h30V39H33zm12-22h6v2h-6zm-10 0h8v4h10v-4h8v20H35z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 57h2v2h-2zM53 57h2v2h-2zM49 57h2v2h-2zM61 21h-2V1H33v20h-2V1H5v20H3c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h5.263A7.953 7.953 0 008 29a7.996 7.996 0 003.585 6.665C5.462 37.555 1 43.265 1 50a5.003 5.003 0 003 4.576V63h27V50c0-6.735-4.462-12.445-10.585-14.335A7.996 7.996 0 0024 29c0-.692-.097-1.359-.263-2H61c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2zM43 3h6v2h-6zm-8 0h6v4h10V3h6v18h-6v-4H41v4h-6zm14 18h-6v-2h6zM15 3h6v2h-6zM7 3h6v4h10V3h6v18h-6v-4H13v4H7zm8 18v-2h6v2zM3 25v-2h7.726a8.069 8.069 0 00-1.644 2zm3 30h4v6H6zm9.5-7H12v-5h7v5h5v13H12v-6h3.5c1.93 0 3.5-1.57 3.5-3.5S17.43 48 15.5 48zm5.5-3.586L22.586 46H21zM29 50v11h-3V46.586L20.414 41H10v7H7v2h8.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H6c-1.654 0-3-1.346-3-3 0-7.168 5.832-13 13-13s13 5.832 13 13zM16 35c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm45-10H22.918a8.047 8.047 0 00-1.644-2H61zM49 53h10v2H49z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInventory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inventory.e1c58382.svg";
export { ForwardRef as ReactComponent };